import css from './index.module.scss';
import { LineSpace } from '@/componentsH5/ProductComponents';
import { BannerModule, TextWithImage } from '@/componentsH5/ProductDetailComponents';
import { getDetaileMoreProducts } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { getImageLocal } from '@/utils/locals';
import OtherList from '@/components/ProductCommon/OtherList';
import { createEFPic } from '@/utils/useEFPic';
import NextImage from '@/components/NextImage';

const { EFPic } = createEFPic('/media/100W_flexible/h5/');

const product: any = {
    us: ['product_ps_river_river_pro_720', 'product_ps_delta_delta_1300', 'product_ps_delta_delta_max'],
    cis: ['product_ps_delta_delta_pro', 'product_ps_delta_delta_max', 'product_ps_river_river_256'],
    eu: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    uk: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    de: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    fr: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    it: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    es: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    tw: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    kr: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    cn: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    br: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_2_max'],
    mx: ['product_ps_river_703', 'product_ps_river_river_512', 'product_ps_river_river_768'],
    ph: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
};

export default function SolarPanel() {
    const { gloproductlist, useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('100wflexiblesolarpanel');
    const imgLocal = getImageLocal(locale, ['de', 'fr', 'jp', 'cis']);
    const webpUrl = '/media/100W_flexible/h5/';

    return (
        <div className={`${css.animationWrapper} solarPanelModule`}>
            <div className="page-solarpanel-banner">
                <BannerModule
                    data={[
                        {
                            bgImgs: ['01.webp', '01.jpg'],
                            title: t('solarpanels_100w_flexible.title'),
                            des: t('solarpanels_100w_flexible.des'),
                        },
                    ]}
                    config={{ isShowLogo: false, webpUrl }}
                />
            </div>
            <div className="banner-content">
                <div className="section sec_top">
                    <div className="tit">{t('solarpanels_100w_flexible.second_light_weight')}</div>
                    <div className="bg-img">
                        <NextImage
                            webpSrc={require('@publicLocal/product/solar_panel_100w_flexible/h5/sec-top.webp')}
                            src={require('@publicLocal/product/solar_panel_100w_flexible/h5/sec-top.jpg')}
                            className="fullImgs"
                            alt={t('solarpanels_100w_flexible.second_light_weight')}
                        />
                    </div>
                </div>
                <div className="sec_bottom">
                    <div className="left">
                        <div className="top section">
                            <div className="tit">{t('solarpanels_100w_flexible.second_flexible_for_h5')}</div>
                            <div className="bg-img">
                                {locale !== 'cis' && (
                                    <EFPic
                                        name={[`sec-bottom-left1_${imgLocal}.webp`, `sec-bottom-left1_${imgLocal}.jpg`]}
                                        className="fullImgs"
                                        alt={t('solarpanels_100w_flexible.second_flexible_for_h5')}
                                    />
                                )}
                                {locale === 'cis' && (
                                    <EFPic
                                        name={['sec-bottom-left1_ru.webp', 'sec-bottom-left1_ru.jpg']}
                                        className="fullImgs"
                                        alt={t('solarpanels_100w_flexible.second_flexible_for_h5')}
                                    />
                                )}
                            </div>
                        </div>
                        <div className="bottom section">
                            <div className="tit">
                                {locale === 'fr' ? (
                                    <>
                                        <div className="text2">{t('solarpanels_100w_flexible.second_waterproof')}</div>
                                        <div className="text1">{t('solarpanels_100w_flexible.second_IP68')}</div>
                                    </>
                                ) : (
                                    <>
                                        <div className="text1">{t('solarpanels_100w_flexible.second_IP68')}</div>
                                        <div className="text2">{t('solarpanels_100w_flexible.second_waterproof')}</div>
                                    </>
                                )}
                            </div>
                            <div className="bg-img">
                                <NextImage
                                    webpSrc={require('@publicLocal/product/solar_panel_100w_flexible/h5/sec-bottom-left2.webp')}
                                    src={require('@publicLocal/product/solar_panel_100w_flexible/h5/sec-bottom-left2.jpg')}
                                    className="fullImgs"
                                    alt={t('solarpanels_100w_flexible.second_IP68')}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="right section">
                        <div className="tit">{t('solarpanels_100w_flexible.second_universally')}</div>
                        <div className="bg-img">
                            <NextImage
                                webpSrc={require('@publicLocal/product/solar_panel_100w_flexible/h5/sec-bottom-right.webp')}
                                src={require('@publicLocal/product/solar_panel_100w_flexible/h5/sec-bottom-right.jpg')}
                                className="fullImgs"
                                alt={t('solarpanels_100w_flexible.second_universally')}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="textImg textData1">
                <TextWithImage
                    config={{ isShowVideo: false, fullScreen: false, position: 'top', webpUrl }}
                    data={{
                        synopsis: t('solarpanels_100w_flexible.third_synopsis'),
                        desc: t('solarpanels_100w_flexible.third_des'),
                        img_url: ['03.webp', '03.jpg'],
                    }}
                />
            </div>
            <LineSpace height={0.8} background="transparent" />
            <div className="textImg textData2">
                <TextWithImage
                    config={{ isShowVideo: false, fullScreen: false, position: 'top', webpUrl }}
                    data={{
                        title: t('solarpanels_100w_flexible.four_title'),
                        synopsis: t('solarpanels_100w_flexible.four_synopsis'),
                        desc: t('solarpanels_100w_flexible.four_des'),
                        img_url: locale === 'cis' ? ['04_ru.webp', '04_ru.jpg'] : [`04_${imgLocal}.webp`, `04_${imgLocal}.jpg`],
                    }}
                />
            </div>
            <LineSpace height={0.8} background="transparent" />
            <div className="textImg textData3">
                <TextWithImage
                    config={{ isShowVideo: false, fullScreen: false, position: 'top', webpUrl }}
                    data={{
                        title: t('solarpanels_100w_flexible.five_title'),
                        synopsis: t('solarpanels_100w_flexible.five_synopsis'),
                        desc: t('solarpanels_100w_flexible.five_des'),
                        img_url: ['05.webp', '05.jpg'],
                    }}
                />
            </div>
            <LineSpace height={0.8} background="transparent" />
            <div className="textImg textData4">
                <TextWithImage
                    config={{ isShowVideo: false, fullScreen: false, position: 'top', webpUrl }}
                    data={{
                        title: t('solarpanels_100w_flexible.six_title'),
                        synopsis: t('solarpanels_100w_flexible.six_synopsis'),
                        desc: t('solarpanels_100w_flexible.six_des'),
                        img_url: ['06.webp', '06.jpg'],
                    }}
                />
            </div>
            <LineSpace height={0.8} background="transparent" />
            <div className="textImg textData5">
                <TextWithImage
                    config={{ isShowVideo: false, fullScreen: false, position: 'top', webpUrl }}
                    data={{
                        title: t('solarpanels_100w_flexible.seven_title'),
                        synopsis: t('solarpanels_100w_flexible.seven_synopsis'),
                        desc: t('solarpanels_100w_flexible.seven_des'),
                        notice: t('solarpanels_100w_flexible.seven_phrase'),
                        img_url: ['07.webp', '07.jpg'],
                    }}
                />
            </div>
            <LineSpace height={0.8} background="transparent" />
            <div className="textImg textData8">
                <TextWithImage
                    config={{
                        isShowVideo: false,
                        fullScreen: false,
                        position: 'top',
                        imgHeight: '2.32rem',
                        webpUrl,
                    }}
                    data={{
                        title: t('solarpanels_100w_flexible.eight_title'),
                        synopsis: t('solarpanels_100w_flexible.eight_synopsis'),
                        desc: t('solarpanels_100w_flexible.eight_des'),
                        img_url: ['08.webp', '08.jpg'],
                    }}
                />
                <div className="img-text text-left">{t('solarpanels_100w_flexible.eight_img_left')}</div>
                <div className="img-text text-right">{t('solarpanels_100w_flexible.eight_img_right')}</div>
            </div>
            <LineSpace height={0.8} background="transparent" />
            <div className="textImg textData9">
                <TextWithImage
                    config={{
                        isShowVideo: false,
                        fullScreen: false,
                        position: 'top',
                        webpUrl,
                    }}
                    data={{
                        title: t('solarpanels_100w_flexible.nine_title'),
                        synopsis: t('solarpanels_100w_flexible.nine_synopsis'),
                        desc: t('solarpanels_100w_flexible.nine_des'),
                        img_url: ['connectors.webp', 'connectors.jpg'],
                    }}
                />
            </div>
            <div className="whatsBox">
                <LineSpace height={0.8} background="transparent" />
                <p className="title">{t('solarpanels_100w_flexible.ten_title')}</p>
                <div className="boxImg">
                    <div className="img">
                        <NextImage
                            webpSrc={require('@publicLocal/product/solar_panel_100w_flexible/h5/09.webp')}
                            src={require('@publicLocal/product/solar_panel_100w_flexible/h5/09.png')}
                            className="fullImgs"
                            alt={t('solarpanels_100w_flexible.ten_title')}
                            aria-label={t('solarpanels_100w_flexible.ten_title')}
                        />
                    </div>
                    <p className="note">{t('solarpanels_100w_flexible.ten_note')}</p>
                </div>
            </div>
            <LineSpace height={1.2} background="transparent" />
            <OtherList
                data={getDetaileMoreProducts(
                    gloproductlist,
                    product[locale] || product.us,
                    '',
                    '',
                    `https://${locale}.ecoflow.com/collections/portable-power-stations`,
                )}
            />
        </div>
    );
}
